<div class="tab-pane" role="tabpanel" id="proyecto">
    <fieldset id="agregar_proyecto" class="">
        <div class="step_section">
            <div class="row" id="row">

                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Caracteristicas del Proyecto</strong><strong
                                *ngIf="n_form == '1.1'"> (Para proyectos de edificación)</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group">
                                <label for="destinos" class="col-md-3" style=" padding-top: 20px;" align="left">Destino
                                    Principal de la Edificaci&oacute;n</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Destino principal de la edificación" id="destinos"
                                            name="destinos" formControlName="destinos">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="superf_existente" class="col-md-3" style=" padding-top: 20px;"
                                    align="left">Superficie Total Existente</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie total existente" id="superf_existente"
                                            name="superf_existente" formControlName="superf_existente"
                                            inputmode=”numeric” pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                        <mat-error *ngIf="form.controls['superf_existente'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="superf_proyectada" class="col-md-3" style=" padding-top: 20px;"
                                    align="left">Superficie Total Proyectada</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie total proyectada" id="superf_proyectada"
                                            name="superf_proyectada" formControlName="superf_proyectada"
                                            inputmode=”numeric” pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                        <mat-error *ngIf="form.controls['superf_proyectada'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>
                                    </mat-form-field>

                                </div>
                                <div class="col-md-1"></div>
                                <label for="npisos" class="col-md-3" style=" padding-top: 20px;" align="left">Nro. Pisos
                                    Sobre NNT</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Nro. Pisos Sobre NNT" id="npisos" name="npisos"
                                            formControlName="npisos" inputmode=”numeric” pattern="[0-9]*">
                                        <mat-error *ngIf="form.controls['npisos'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <label for="superf_terreno" class="col-md-3" style=" padding-top: 20px;">Superficie
                                    Total Terreno</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie Total Terreno" id="superf_terreno"
                                            name="superf_terreno" formControlName="superf_terreno" inputmode=”numeric”
                                            pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                        <mat-error *ngIf="form.controls['superf_terreno'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <label for="" class="col-md-3"></label>
                                <div class="col-md-3">
                                </div>
                            </div>
                            <hr />
                            <div class="form-group" align="left">
                                <label for="coef_construct" class="col-md-1"
                                    style="margin-right: 30px; padding-top: 20px;">COEF. CONSTRUCT</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="COEF. CONSTRUCT" id="coef_construct"
                                            name="coef_construct" formControlName="coef_construct" inputmode=”numeric”
                                            pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                        <mat-error *ngIf="form.controls['coef_construct'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <label for="ocupadoc" class="col-md-1"
                                    style="margin-right: 30px; padding-top: 20px; padding-right: 0px">OCUPADO</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="OCUPADO" id="ocupadoc" name="ocupadoc"
                                            formControlName="ocupadoc" inputmode=”numeric”
                                            pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                        <mat-error *ngIf="form.controls['ocupadoc'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>

                                    </mat-form-field>
                                </div>
                                <label for="proyectadoc" class="col-md-2"
                                    style=" padding-top: 20px; padding-right: 0px">PROYECTADO</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="PROYECTADO" id="proyectadoc" name="proyectadoc"
                                            formControlName="proyectadoc" inputmode=”numeric”
                                            pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                            <mat-error *ngIf="form.controls['proyectadoc'].hasError('pattern')">
                                                Solo se permiten caracteres <strong>numéricos</strong>
                                            </mat-error>
    
                                    </mat-form-field>
                                </div>
                            </div>
                            <br />
                            <div class="form-group" align="left">
                                <label for="coef_ocupacion" class="col-md-1"
                                    style="margin-right: 30px; padding-top: 20px;">COEF. OCUPACION DE SUELO</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="COEF. OCUPACION DE SUELO" id="coef_ocupacion"
                                            name="coef_ocupacion" formControlName="coef_ocupacion" inputmode=”numeric”
                                            pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                            <mat-error *ngIf="form.controls['coef_ocupacion'].hasError('pattern')">
                                                Solo se permiten caracteres <strong>numéricos</strong>
                                            </mat-error>
                                    </mat-form-field>
                                </div>
                                <label for="ocupadooc" class="col-md-1"
                                    style=" margin-right: 30px; padding-top: 20px; padding-right: 0px">OCUPADO</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="OCUPADO" id="ocupadooc" name="ocupadooc"
                                            formControlName="ocupadooc" inputmode=”numeric”
                                            pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                            <mat-error *ngIf="form.controls['ocupadooc'].hasError('pattern')">
                                                Solo se permiten caracteres <strong>numéricos</strong>
                                            </mat-error>
                                    </mat-form-field>
                                </div>
                                <label for="proyectadooc" class="col-md-2"
                                    style=" padding-top: 20px;padding-right: 0px">PROYECTADO</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="PROYECTADO" id="proyectadooc" name="proyectadooc"
                                            formControlName="proyectadooc" inputmode=”numeric”
                                            pattern="[0-9]*">
                                        <span matSuffix>m²</span>
                                            <mat-error *ngIf="form.controls['proyectadooc'].hasError('pattern')">
                                                Solo se permiten caracteres <strong>numéricos</strong>
                                            </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <hr />
                            <div class="form-group" align="left">
                                <label for="autorizacion" class="col-md-2" style="padding-top: 10px;">AUTORIZACIONES
                                    ESPECIALES:</label>

                                <div class="col-md-3">
                                    <mat-checkbox formControlName="autorizacion1" id="autorizacion1"
                                        name="autorizacion1">Art. 121 LGUC</mat-checkbox>
                                    <!--en form (no dialog)-->
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox formControlName="autorizacion2" id="autorizacion2"
                                        name="autorizacion2">Art. 122 LGUC</mat-checkbox>
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox formControlName="autorizacion3" id="autorizacion3"
                                        name="autorizacion3">Art. 123 LGUC</mat-checkbox>
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox formControlName="autorizacion4" id="autorizacion4"
                                        name="autorizacion4">Art. 124 LGUC</mat-checkbox>
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox formControlName="autorizacion5" id="autorizacion5"
                                        name="autorizacion5">Ley 19537</mat-checkbox>
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox formControlName="autorizacion6" id="autorizacion6"
                                        name="autorizacion6">Otro</mat-checkbox>
                                </div>

                            </div>
                            <hr />
                            <div class="form-group" align="left">
                                <label for="uso_publico" class="col-md-2">Edificio de Uso P&uacute;blico:</label>
                                <div class="col-md-2">
                                    <mat-radio-group formControlName="uso_publico">
                                        <mat-radio-button style="padding-right: 20px" name="uso_publico" value="SI">SI
                                        </mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="uso_publico" value="NO">NO
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="edif_nac" class="col-md-4">Edificio Declarado Monumento Nacional/zona de
                                    Conservacion</label>
                                <div class="inline">
                                    <mat-radio-group formControlName="edif_nac">
                                        <mat-radio-button style="padding-right: 20px" name="edif_nac" value="SI">SI
                                        </mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="edif_nac" value="NO">NO
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-12" align="center" style="padding-top: 30px;">
                                    <button mat-raised-button color="primary" style="padding-top: 5px"
                                        id="ingreso_proyecto" (click)="add_proyecto()">
                                        Agregar Proyecto
                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </form>

                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                            [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>DESTINO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.destinos}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERF EXISTENTE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superf_existente}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERF PROY</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superf_proyectada}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NRO PISOS</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.npisos}}
                                </ng-template>
                            </ngx-datatable-column>
                            <!-- <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUPERF TERRENO</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.superf_terreno}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>COEF. CONTRUC</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.coef_construct}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OCUP</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.ocupadoc}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>PROYECT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.proyectadoc}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>COEF. OCUP</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.coef_ocupacion}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OCUP</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.ocupadooc}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>PROY</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.proyectadooc}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>AUTORIZ</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.autorizacion}}
                                </ng-template>
                            </ngx-datatable-column> -->
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>USO PUB.</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <strong *ngIf="row.uso_publico == 'SI'">Si</strong>
                                    <strong *ngIf="row.uso_publico == 'NO'">No</strong>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>EDIF. NAC</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <strong *ngIf="row.edif_nac == 'SI'">Si</strong>
                                    <strong *ngIf="row.edif_nac == 'NO'">No</strong>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="get_proyecto(rowIndex)" style="padding-right: 5px;"><i
                                            class="glyphicon glyphicon-pencil"></i></span>
                                    <span (click)="delete_proyecto(rowIndex)"><i
                                            class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>

    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del Proyecto</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion solicitada</strong>
                </div>
                <div class="form-group">
                    <label for="destinos" class="col-md-3" style=" padding-top: 15px;" align="left">Destino Principal de
                        la Edificaci&oacute;n</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="Destino principal de la edificación" id="destinos"
                                name="destinos" [(ngModel)]="temp_proy.destinos">
                            <!-- <mat-error *ngIf="form.controls?.destinos.hasError('required')">
                                    Este campo es <strong>obligatorio</strong>
                                </mat-error> -->
                        </mat-form-field>
                    </div>
                    <div class="col-md-1"></div>
                    <label for="superf_existente" class="col-md-3" style=" padding-top: 15px;" align="left">Superficie
                        Total Existente</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="Superficie total existente" id="superf_existente"
                                name="superf_existente" [(ngModel)]="temp_proy.superf_existente" inputmode=”numeric” pattern="[0-9]*">
                            <span matSuffix>m²</span>
                            <!-- <mat-error *ngIf="form.controls?.superf_existente.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group">
                    <label for="superf_proyectada" class="col-md-3" style=" padding-top: 15px;" align="left">Superficie
                        Total Proyectada</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="Superficie total proyectada" id="superf_proyectada"
                                name="superf_proyectada" [(ngModel)]="temp_proy.superf_proyectada" inputmode=”numeric” pattern="[0-9]*">
                            <span matSuffix>m²</span>
                            <!-- <mat-error *ngIf="form.controls?.superf_proyectada.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>

                    </div>
                    <div class="col-md-1"></div>
                    <label for="npisos" class="col-md-3" style=" padding-top: 15px;" align="left">Nro. Pisos Sobre
                        NNT</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="Nro. Pisos Sobre NNT" id="npisos" name="npisos"
                                [(ngModel)]="temp_proy.npisos" inputmode=”numeric” pattern="[0-9]*">
                            <!-- <mat-error *ngIf="form.controls?.npisos.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group" align="left">
                    <label for="superf_terreno" class="col-md-3" style=" padding-top: 15px;">Superficie Total
                        Terreno</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="Superficie Total Terreno" id="superf_terreno"
                                name="superf_terreno" [(ngModel)]="temp_proy.superf_terreno" inputmode=”numeric” pattern="[0-9]*">
                            <span matSuffix>m²</span>
                            <!-- <mat-error *ngIf="form.controls?.superf_terreno.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <label for="" class="col-md-3"></label>
                    <div class="col-md-3">
                    </div>
                </div>
                <hr />
                <div class="form-group" align="left">
                    <label for="coef_construct" class="col-md-2" style=" padding-top: 15px;">COEF. CONSTRUCT</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="COEF. CONSTRUCT" id="coef_construct" name="coef_construct"
                                [(ngModel)]="temp_proy.coef_construct" inputmode=”numeric” pattern="[0-9]*">
                            <!-- <mat-error *ngIf="form.controls?.coef_construct.hasError('required')">
                                    Este campo es <strong>obligatorio</strong>
                                </mat-error> -->
                        </mat-form-field>
                    </div>
                    <label for="ocupadoc" class="col-md-2" style=" padding-top: 15px;">OCUPADO</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="OCUPADO" id="ocupadoc" name="ocupadoc"
                                [(ngModel)]="temp_proy.ocupadoc" inputmode=”numeric” pattern="[0-9]*">
                            <!-- <mat-error *ngIf="form.controls?.ocupadoc.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <label for="proyectadoc" class="col-md-2" style=" padding-top: 15px;">PROYECTADO</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="PROYECTADO" id="proyectadoc" name="proyectadoc"
                                [(ngModel)]="temp_proy.proyectadoc" inputmode=”numeric” pattern="[0-9]*">
                            <!-- <mat-error *ngIf="form.controls?.proyectadoc.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                </div>
                <br />
                <div class="form-group" align="left">
                    <label for="coef_ocupacion" class="col-md-2" style=" padding-top: 15px;">COEF. OCUPACION DE
                        SUELO</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="COEF. OCUPACION DE SUELO" id="coef_ocupacion"
                                name="coef_ocupacion" [(ngModel)]="temp_proy.coef_ocupacion" inputmode=”numeric” pattern="[0-9]*">
                            <!-- <mat-error *ngIf="form.controls?.coef_ocupacion.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <label for="ocupadooc" class="col-md-2" style=" padding-top: 15px;">OCUPADO</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="OCUPADO" id="ocupadooc" name="ocupadooc"
                                [(ngModel)]="temp_proy.ocupadooc" inputmode=”numeric” pattern="[0-9]*">
                            <!-- <mat-error *ngIf="form.controls?.ocupadooc.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <label for="proyectadooc" class="col-md-2" style=" padding-top: 15px;">PROYECTADO</label>
                    <div class="col-md-2">
                        <mat-form-field class="example-full-width" style="width: 145px;">
                            <input matInput placeholder="PROYECTADO" id="proyectadooc" name="proyectadooc"
                                [(ngModel)]="temp_proy.proyectadooc" inputmode=”numeric” pattern="[0-9]*">
                            <!-- <mat-error *ngIf="form.controls?.proyectadooc.hasError('required')">
                                Este campo es <strong>obligatorio</strong>
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                </div>
                <hr />
                <div class="form-group" align="left">
                    <label for="autorizacion" class="col-md-2" style="padding-top: 10px;">AUTORIZACIONES
                        ESPECIALES:</label>
                    <div class="col-md-3">
                        <mat-checkbox [checked]="temp_proy.Art121" name="autorizacion1" value="1">Art. 121 LGUC
                        </mat-checkbox>
                        <!--dentro del dialog-->
                    </div>
                    <div class="col-md-3">
                        <mat-checkbox [checked]="temp_proy.Art122" name="autorizacion2" value="2">Art. 122 LGUC
                        </mat-checkbox>
                    </div>
                    <div class="col-md-3">
                        <mat-checkbox [checked]="temp_proy.Art123" name="autorizacion3" value="3">Art. 123 LGUC
                        </mat-checkbox>
                    </div>
                    <div class="col-md-3">
                        <mat-checkbox [checked]="temp_proy.Art124" name="autorizacion4" value="4">Art. 124 LGUC
                        </mat-checkbox>
                    </div>
                    <div class="col-md-3">
                        <mat-checkbox [checked]="temp_proy.Ley19537" name="autorizacion5" value="5">Ley 19537
                        </mat-checkbox>
                    </div>
                    <div class="col-md-3">
                        <mat-checkbox [checked]="temp_proy.Otro" name="autorizacion6" value="6">Otro</mat-checkbox>
                    </div>

                </div>
                <div class="form-group" align="left">
                    <div class="col-md-4">
                        <label for="autorizacion" class="col-md-5" style="padding-top: 10px;">Edificio de uso
                            p&iacute;blico:</label>
                        <div class="col-md-7">
                            <div class="col-md-4">
                                <label style="padding-right: 20px">SI </label>
                                <input style="width: 21px" type="radio" id="uso_publico" name="uso_publico" value="SI"
                                    [(ngModel)]="temp_proy.uso_publico" class="form-control input-md" />
                            </div>
                            <div class="col-md-6">
                                <label style="padding-right: 20px">NO </label>
                                <input style="width: 21px" type="radio" id="uso_publico" name="uso_publico" value="NO"
                                    [(ngModel)]="temp_proy.uso_publico" class="form-control input-md" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="autorizacion" class="col-md-7" style="padding-top: 10px;">Edificio declarado
                            monumento nacional/zona de Conservaci&oacute;n:</label>
                        <div class="col-md-5">
                            <div class="col-md-4">
                                <label style="padding-right: 20px">SI </label>
                                <input style="width: 21px" type="radio" id="edif_nac" name="edif_nac" value="SI"
                                    [(ngModel)]="temp_proy.edif_nac" class="form-control input-md" />
                            </div>
                            <div class="col-md-6">
                                <label style="padding-right: 20px">NO </label>
                                <input style="width: 21px" type="radio" id="edif_nac" name="edif_nac" value="NO"
                                    [(ngModel)]="temp_proy.edif_nac" class="form-control input-md" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_proyecto" data-dismiss="modal"
                (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_proyecto" (click)="saveProyecto() ">Ingresar Proyecto
                <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
        No ingreso ningun dato al proyecto.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
            (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #openModalNOVALID>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       Ingreso datos incorrectos al antecedente.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>

<div class="separator"></div>